<template>
  <el-badge :hidden="!noticeUnReadNum" type="danger" :value="noticeUnReadNum">
    <vab-icon icon="notification-line" @click="handleShowDrawer" />
  </el-badge>
  <el-drawer
    v-model="showDrawer"
    append-to-body
    class="drawer-notice-class drawer-notice-modal-class"
    header-class="mb0"
    size="25%"
    :z-index="2000"
  >
    <template #header>
      <div>
        <span class="fs16 b">站内信</span>
        <span
          v-if="noticeUnReadNum"
          class="c0 fs14 cp ml4"
          @click="handleReadAllNotice"
        >
          全部已读
        </span>
      </div>
    </template>
    <div class="fv h">
      <div class="p10 bbor fx">
        <el-select
          v-model="read_status"
          class="w150"
          clearable
          filterable
          placeholder="消息状态"
          @change="handleSelectChange"
        >
          <el-option label="全部" value="" />
          <el-option
            v-for="(key, val) in MESSAGE_STATUS"
            :key="key"
            :label="key"
            :value="val"
          />
        </el-select>
        <el-select
          v-model="msg_type"
          class="w150 ml10"
          clearable
          filterable
          placeholder="消息类型"
          @change="handleSelectChange"
        >
          <el-option label="全部" value="" />
          <el-option
            v-for="(key, val) in MESSAGE_TYPE"
            :key="key"
            :label="key"
            :value="val"
          />
        </el-select>
      </div>
      <div v-infinite-scroll="handleGetNoticeList" class="ex oy mh0">
        <div
          v-for="(item, index) in listData"
          :key="index"
          class="infinite-list-item bbor plr15"
          @click="handleReadNotice(item, index)"
        >
          <div class="fxmj ptb10">
            <view class="g1 b">
              <span
                class="dl ptb2 plr10 bgtl r100px tags c0 fs12"
                :class="[item.read_status ? 'read' : 'tag']"
              >
                {{ MESSAGE_TYPE[item.type] }}
              </span>
              {{ item.title }}
            </view>

            <span>{{ item.create_time }}</span>
          </div>
          <div class="pb10 pt5 b pl5 fxmj" :class="[item.status ? 'g9' : 'g6']">
            <div v-html="item.content" class="ex"></div>
            <span v-if="!item.status" class="c0">标记已读</span>
            <a
              v-if="item?.file"
              class="c0 ml10"
              download
              :href="item.file"
              @click.stop
            >
              下载文件
            </a>
            <span
              v-if="item.module"
              class="c0 ml10"
              @click.stop="handleLookDraw(item)"
            >
              去处理
            </span>
          </div>
        </div>
        <div
          v-if="pagination.last_page && pagination.page > pagination.last_page"
          class="tc ptb10"
        >
          没有更多了~
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
  import {
    defineComponent,
    getCurrentInstance,
    reactive,
    toRefs,
    onMounted,
    onUnmounted,
    computed,
  } from 'vue'
  import { ElMessage } from 'element-plus'
  import dayjs from 'dayjs'
  import { useStore } from 'vuex'
  import { translateTitle } from '@/utils/i18n'
  import { getNoticeList, readNotice, readAllNotice } from '@/api/notice'
  import { getCompanyInfo } from '@/api/user'
  import { MESSAGE_STATUS, MESSAGE_TYPE } from '@/config/variable.config'
  import { handleOpenDraw } from '@/utils/business'
  import { pageDetailConfig } from '@/componentsBusiness/config'
  export default defineComponent({
    name: 'VabNotice',
    setup() {
      const store = useStore()
      const { proxy } = getCurrentInstance()
      const noticeUnReadNum = computed(
        () => store.getters['sys/noticeUnReadNum']
      )
      const userMenusAuthModuleObj = computed(() => {
        const userMenusAuthObj = store.getters['routes/menusObj']
        const result = {}
        Object.keys(userMenusAuthObj).forEach((key) => {
          if (userMenusAuthObj[key].org_module) {
            result[userMenusAuthObj[key].org_module] = {
              url: key,
              title: userMenusAuthObj[key].title,
            }
          }
        })
        return result
      })
      const pageDetailConfigObj = computed(() => {
        const result = {}
        Object.keys(pageDetailConfig).forEach((key) => {
          result[pageDetailConfig[key].url] = key
        })
        return result
      })
      const noticeSubType = computed(() => store.getters['sys/noticeSubType'])
      const noticeTypeTree = computed(() => store.getters['sys/noticeTypeTree'])
      const state = reactive({
        time: `${dayjs().subtract(1, 'month').format('YYYY-MM-DD')} 00:00:00`,
        unReadNum: 0,
        timer: null,
        showDrawer: false,
        msg_type: '',
        msg_sub_type: '',
        read_status: '',
        listData: [],
        pagination: {
          page: 1,
          per_page: 10,
        },
        props1: {
          checkStrictly: true,
          label: 'title',
          value: 'id',
        },
      })

      const handleShowDrawer = () => {
        if (state.showDrawer) {
          state.showDrawer = false
          return
        }
        state.showDrawer = true
      }

      const handleSelectChange = () => {
        state.pagination.page = 1
        handleGetNoticeList()
      }

      const handleGetCompanyInfo = () => {
        getCompanyInfo().then((res) => {
          store.commit('sys/setWebsiteData', res || {})
        })
      }
      const handleGetNoticeList = () => {
        if (state.pagination.page > state.pagination.last_page) return
        const params = {
          type: state.msg_type,
          // msg_sub_type: state.msg_sub_type,
          status: state.read_status,
          page: state.pagination.page,
          per_page: state.pagination.per_page,
          // create_time_start: state.time,
          sort: 'id',
          order: 'desc',
        }
        getNoticeList(params).then((res) => {
          if (res.current_page === 1) {
            state.listData = res.data || []
          } else {
            state.listData = state.listData.concat(res.data)
          }
          state.pagination = {
            current_page: res.current_page,
            last_page: res.last_page,
            per_page: res.per_page,
            total: res.total,
            page: state.pagination.page + 1,
          }
        })
      }

      const handleReadNotice = (item, index) => {
        if (item.status) return
        const params = {
          id: item.id,
        }
        readNotice(params).then((res) => {
          console.log('res', res)
          state.listData[index].status = 1
          handleGetCompanyInfo()
        })
      }

      const handleClearNotice = () => {
        proxy.$baseMessage('清空消息成功', 'success', 'vab-hey-message-success')
      }

      const handleReadAllNotice = () => {
        const params = {}
        readAllNotice(params).then((res) => {
          console.log('res', res)
          handleGetCompanyInfo()
          handleGetNoticeList()
        })
      }

      const handleLookDraw = (item) => {
        console.log('userMenusAuthObj', userMenusAuthModuleObj.value)
        const { ref_id, module } = item
        const modulePath = userMenusAuthModuleObj.value[module]?.url
        const drawPath = pageDetailConfigObj.value[modulePath]
        if (drawPath) {
          handleOpenDraw(
            { ...item, id: ref_id },
            {
              publicDrawerConfig: {
                openName: drawPath,
              },
            }
          )
        } else {
          ElMessage.warning('暂未找到关联模块')
        }
      }
      onMounted(() => {})

      onUnmounted(() => {
        clearInterval(state.timer)
      })
      return {
        ...toRefs(state),
        noticeTypeTree,
        noticeSubType,
        MESSAGE_STATUS,
        MESSAGE_TYPE,
        noticeUnReadNum,
        translateTitle,
        handleClearNotice,
        handleShowDrawer,
        handleGetNoticeList,
        handleReadNotice,
        handleReadAllNotice,
        handleSelectChange,
        handleLookDraw,
      }
    },
  })
</script>

<style lang="scss">
  @import '../../../styles/variable.scss';
  .drawer-notice-class {
    display: flex;
    flex-direction: column;
    height: auto !important;
    background-color: #fff;

    // top: 60px !important;
    .el-drawer__body {
      flex: 1;
      padding: 0;
      min-height: 0;
      background-color: #fff;
      .infinite-list-item {
        .tags {
          border: 1px solid $primary-opt;
        }
        .read {
          background-color: #e7eaef;
          color: #fff;
        }

        &:hover {
          cursor: pointer;
          background-color: #e7eaef;
          .tag {
            background-color: $primary;
            // border: 1px solid $primary;
            color: #fff;
          }
          .read {
            border: 1px solid #fff;
          }
        }
      }
    }
  }
  .drawer-notice-modal-class {
    // background-color: transparent;
    .el-drawer__header {
      margin-bottom: 0 !important;
    }
  }
</style>
